module.exports = __webpack_public_path__ + "img/ic_phone_3.e7b7def8.svg";